import { IBizDays } from '@/appLogic/interfaces/date';

type BinaryFunctionValue = number | IBizDays;

type BinaryFunctionType<T = BinaryFunctionValue> = (a: T, b: T) => number;
/**
 * 0番目に目的のindex なければ-1を返す,
 * 1番目に目的のindexに一番近い目的のindexよりも小さい数,
 * 2番目に目的のindexに一番近い目的のindexよりも大きい数
 * @param array {BinaryFunctionValue[]}
 * @param target {BinaryFunctionValue}
 * @param func {BinaryFunctionType}
 * @returns [targetIndex, minIndex, maxIndex]
 */
export default function <T = BinaryFunctionValue>(array: T[], target: T, func: BinaryFunctionType<T>): number[] {
  let targetIndex = -1;
  let minIndex = 0;
  let maxIndex = array.length - 1;
  while (minIndex <= maxIndex) {
    const mid = Math.floor((minIndex + maxIndex) / 2);
    if (func(array[mid], target) == 0) {
      targetIndex = mid;
      break;
    } else if (func(array[mid], target) < 0) {
      minIndex = mid + 1;
    } else {
      maxIndex = mid - 1;
    }
  }
  // whileが終わる段階でminIndex > maxIndex
  const swap = minIndex;
  minIndex = maxIndex;
  maxIndex = swap;
  return [targetIndex, minIndex, maxIndex];
}
